import { useMemo } from 'react';
import { useImportContext } from '../components/import-context';

export const useCanStartImport = () => {
  const { isImportLoading, isInitImportLoading, isMappingResultValid, isMappingNameUnique, mappingName, initRequest } = useImportContext();

  const canRequestInitImport = useMemo(() => {
    const isColumnMappingResultInvalid = !isMappingResultValid;
    const isBackgroundProcessLoading = isImportLoading || isInitImportLoading;
    // if template is selected, we don't need to validate mapping name
    // because user can't change it
    if (initRequest.mapping.mappingId) {
      return isColumnMappingResultInvalid || isBackgroundProcessLoading;
    }
    return isColumnMappingResultInvalid || isBackgroundProcessLoading || !isMappingNameUnique(mappingName);
  }, [initRequest.mapping.mappingId, isImportLoading, isInitImportLoading, isMappingNameUnique, isMappingResultValid, mappingName]);

  return canRequestInitImport;
};
